import { render, staticRenderFns } from "./TransactionItemDetail.vue?vue&type=template&id=098551ea&scoped=true&"
import script from "./TransactionItemDetail.vue?vue&type=script&lang=ts&"
export * from "./TransactionItemDetail.vue?vue&type=script&lang=ts&"
import style0 from "./TransactionItemDetail.vue?vue&type=style&index=0&id=098551ea&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "098551ea",
  null
  
)

export default component.exports